/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';

/**
 * 
 * @export
 * @interface UpdateLeadWaitlistStatus200Response
 */
export interface UpdateLeadWaitlistStatus200Response {
    /**
     * 
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist;
}

/**
 * Check if a given object implements the UpdateLeadWaitlistStatus200Response interface.
 */
export function instanceOfUpdateLeadWaitlistStatus200Response(value: object): value is UpdateLeadWaitlistStatus200Response {
    return true;
}

export function UpdateLeadWaitlistStatus200ResponseFromJSON(json: any): UpdateLeadWaitlistStatus200Response {
    return UpdateLeadWaitlistStatus200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadWaitlistStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadWaitlistStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON(json['data']),
    };
}

export function UpdateLeadWaitlistStatus200ResponseToJSON(json: any): UpdateLeadWaitlistStatus200Response {
    return UpdateLeadWaitlistStatus200ResponseToJSONTyped(json, false);
}

export function UpdateLeadWaitlistStatus200ResponseToJSONTyped(value?: UpdateLeadWaitlistStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON(value['data']),
    };
}

